import { render, staticRenderFns } from "./ReservedFieldDialog.vue?vue&type=template&id=65564d62&scoped=true"
import script from "./ReservedFieldDialog.vue?vue&type=script&lang=js"
export * from "./ReservedFieldDialog.vue?vue&type=script&lang=js"
import style0 from "./ReservedFieldDialog.vue?vue&type=style&index=0&id=65564d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65564d62",
  null
  
)

export default component.exports